export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/mw.0faa1d19.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};